import { Cell } from 'react-table';

import { CellText } from 'coreOld/elements';
import { AlignText } from 'coreOld/enums';
import { formatDate, getPercentage, getRawQuantity } from 'coreOld/utils';
import { CostingStatus } from 'partsOld/enums';
import { ICompanyPart, IPricing, IPricingItem } from 'partsOld/types';

const statusLabel = {
  [CostingStatus.Expired]: 'Expired',
  [CostingStatus.Pending]: 'Pending',
  [CostingStatus.Active]: 'Active',
};

const getPriceItems = (items, uom: string, field: string, part?: Partial<ICompanyPart>) => {
  if (!items) {
    return '-';
  }

  return items.map((item) => {
    if (!item[field]) {
      return '-';
    }

    return `${getRawQuantity(item[field], part?.bomPriceDecimals)} / ${uom || '-'}`;
  });
};

const getPriceDiscountMargin = (items: IPricingItem[], field: string) => {
  if (!items) {
    return;
  }

  return items.map((item) => {
    if (!item[field]) {
      return '-';
    }

    return getPercentage(Number(item[field]) / 100);
  });
};

export const columns = (part: Partial<ICompanyPart>) => [
  {
    Header: 'Start Date',
    accessor: 'startDate',
    Cell: ({ row }: Cell<IPricing>) => {
      const date = formatDate(row.original.startDate, true);

      return <CellText mainText={date?.split(' ')[0]} subTexts={[date?.split(' ')[1]]} />;
    },
    flex: 100,
  },
  {
    Header: 'End Date',
    accessor: 'endDate',
    Cell: ({ row }: Cell<IPricing>) => {
      const date = formatDate(row.original.endDate, true);

      return <CellText mainText={date?.split(' ')[0]} subTexts={[date?.split(' ')[1]]} />;
    },
    flex: 100,
  },
  {
    Header: 'Status',
    accessor: 'status',
    Cell: ({ row }: Cell<IPricing>) => (
      <CellText
        mainText={statusLabel[row.original.status]}
        subTexts={[
          row.original.createdAt,
          `${row.original.userFirstName} ${row.original.userLastName}`,
        ]}
      />
    ),
    flex: 100,
  },
  {
    id: 1,
    Header: () => <CellText mainText="Min Qty" alignText={AlignText.RIGHT} />,
    Cell: ({ row }: Cell<IPricing>) => (
      <CellText
        alignText={AlignText.RIGHT}
        mainText={getPriceItems(row.original?.priceItems, part?.uom, 'minQuantity', part)}
      />
    ),
    flex: 120,
  },
  {
    id: 2,
    Header: () => <CellText mainText="Max Qty" alignText={AlignText.RIGHT} />,
    Cell: ({ row }: Cell<IPricing>) => (
      <CellText
        alignText={AlignText.RIGHT}
        mainText={getPriceItems(row.original?.priceItems, part?.uom, 'maxQuantity', part)}
      />
    ),
    flex: 120,
  },
  {
    id: 3,
    Header: () => <CellText mainText="Margin" alignText={AlignText.RIGHT} />,
    Cell: ({ row }: Cell<IPricing>) => (
      <CellText
        alignText={AlignText.RIGHT}
        mainText={getPriceDiscountMargin(row.original?.priceItems, 'marginReduction')}
      />
    ),
    flex: 100,
  },
  {
    id: 4,
    Header: () => <CellText mainText="Discount" alignText={AlignText.RIGHT} />,
    Cell: ({ row }: Cell<IPricing>) => (
      <CellText
        alignText={AlignText.RIGHT}
        mainText={getPriceDiscountMargin(row.original?.priceItems, 'discountIncrease')}
      />
    ),
  },
];
